export default __webpack_public_path__ + "static/media/night.03748349.png";